/**
 * PopularTopicsSlider.js — 3D coverflow slider for "Most Popular Topics"
 * Autoplays forward (pausing on hover) but does not loop back to the
 * start — crossfades an ambient blurred backdrop to match whichever
 * topic card is centered.
 */
import Swiper from 'swiper';
import { EffectCoverflow, Navigation, Pagination, Autoplay } from 'swiper/modules';

export default class PopularTopicsSlider {
  constructor(selector = '.popular-topics-slider') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    const stage = this.el.closest('.popular-topics-stage');
    const ambientLayers = stage ? [...stage.querySelectorAll('.ambient-layer')] : [];
    let visibleLayer = 0;

    const setAmbient = (bgUrl) => {
      if (!bgUrl || ambientLayers.length < 2) return;
      const next = ambientLayers[1 - visibleLayer];
      const current = ambientLayers[visibleLayer];
      next.style.backgroundImage = `url(${bgUrl})`;
      next.classList.add('is-visible');
      current.classList.remove('is-visible');
      visibleLayer = 1 - visibleLayer;
    };

    const activeBg = (swiper) => {
      const active = swiper.slides[swiper.activeIndex];
      return active?.querySelector('.popular-topic-card')?.dataset.bg;
    };

    this.swiper = new Swiper(this.el, {
      modules: [EffectCoverflow, Navigation, Pagination, Autoplay],
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      loop: false,
      speed: 700,
      slidesPerView: 'auto',
      spaceBetween: 28,
      coverflowEffect: {
        rotate: 28,
        stretch: 0,
        depth: 220,
        modifier: 1,
        slideShadows: false,
      },
      autoplay: {
        delay: 3200,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        stopOnLastSlide: true,
      },
      navigation: {
        nextEl: '.popular-topics-next',
        prevEl: '.popular-topics-prev',
      },
      pagination: {
        el: '.popular-topics-pagination',
        clickable: true,
      },
      on: {
        init: (swiper) => {
          const bg = activeBg(swiper);
          if (bg && ambientLayers[0]) {
            ambientLayers[0].style.backgroundImage = `url(${bg})`;
            ambientLayers[0].classList.add('is-visible');
            visibleLayer = 0;
          }
        },
        slideChangeTransitionStart: (swiper) => setAmbient(activeBg(swiper)),
      },
    });
  }
}
